import React, {useEffect, useState} from 'react';
import Modal from 'react-modal';
import styles from './CreateTaxInvoicePopUp.module.css';
import Button from '../../../components/common/button/Button';
import {useAlert} from "../../../components/common/error/AlertContext";
import {CreateAdminTaxInvoiceRequest, GetPaidPaymentResponseData} from "../../../types/admin";
import {createAdminTaxInvoiceAPI, getAdminPaidPaymentsAPI} from "../../../services/admin";

interface CreateTaxInvoicePopUpProps {
    isOpen: boolean;
    onClose: () => void;
}

//세금계산서 생성 팝업
const CreateTaxInvoicePopUp: React.FC<CreateTaxInvoicePopUpProps> = ({
                                                                                             isOpen,
                                                                                             onClose
                                                                                         }) => {
    const [requestData, setRequestData] = useState<CreateAdminTaxInvoiceRequest>({
        paymentId: 0,
        purpose: "영수",
        managerName: "",
        managerNumber: "",
        email: "",
        total: 0
    });
    const [payments, setPayments] = useState<GetPaidPaymentResponseData[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const {showAlert} = useAlert();

    const fetchPayments = async () => {
        try {
            // 승인된 클라이언트 목록 조회 API
            const response = await getAdminPaidPaymentsAPI();
            setPayments(response);
        } catch (error) {
            console.error('Error fetching clients:', error);
        }
    };

    useEffect(() => {
        fetchPayments();
    }, []);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (isLoading) return;
        //입력 필수값 확인
        if (requestData.purpose === "") {
            showAlert('목적을 선택해주세요.', "error");
            return;
        }
        if (requestData.paymentId === 0) {
            showAlert('대상 결제를 선택해주세요.', "error");
            return;
        }
        if (requestData.total === 0) {
            showAlert('총액을 선택해주세요.', "error");
            return;
        }

        setIsLoading(true);
        try {
            await createAdminTaxInvoiceAPI(requestData);
            setRequestData({
                paymentId: 0,
                purpose: "영수",
                managerName: "",
                managerNumber: "",
                email: "",
                total: 0
            });
            onClose();
            showAlert('세금계산서가 발행 되었습니다.', "info");
            fetchPayments();
        } catch (error) {
            console.error('Worker request failed:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Modal
                isOpen={isOpen}
                onRequestClose={onClose}
                className={styles.modal}
                overlayClassName={styles.overlay}
            >
                <div className={styles.modalContent}>
                    <div className={styles.header}>
                        <h2>세금계산서 직접 발행</h2>
                        <button onClick={onClose} className={styles.closeButton} type="button" aria-label="Close">×
                        </button>
                    </div>
                    <form onSubmit={handleSubmit} className={styles.form}>
                        <div className={styles.formGroup}>
                            <label>결제</label>
                            {/*대상 결제 선택*/}
                            <select
                                value={requestData.paymentId}
                                onChange={(e) => {
                                    const selectedPaymentId = parseInt(e.target.value);
                                    const selectedPayment = payments.find(p => p.paymentId === selectedPaymentId);
                                    setRequestData(prev => ({
                                        ...prev,
                                        paymentId: selectedPaymentId,
                                        total: selectedPayment ? selectedPayment.total : 0,
                                        managerName: selectedPayment ? selectedPayment.managerName : "",
                                        managerNumber: selectedPayment ? selectedPayment.managerNumber : "",
                                        email: selectedPayment ? selectedPayment.email : ""

                                    }))
                                }}
                                className={styles.select}
                                disabled={isLoading}
                            >
                                <option value={0}>선택해주세요</option>
                                {payments.map(payment => (
                                    <option key={payment.paymentId} value={payment.paymentId}>
                                        {"[" + payment.companyName + "] " + payment.orderName}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className={styles.formGroup}>
                            <label>총액</label>
                            <input
                                type="number"
                                value={requestData.total === 0 ? '' : requestData.total}
                                onChange={(e) => {
                                    const value = parseInt(e.target.value) || 0;
                                    setRequestData(prev => ({
                                        ...prev,
                                        total: value
                                    }));
                                }}
                                min="0"
                                className={styles.input}
                                disabled={isLoading}
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label>발행 목적</label>
                            {/*발행 목적*/}
                            <select
                                value={requestData.purpose}
                                onChange={(e) => {
                                    const value = e.target.value
                                    setRequestData(prev => ({
                                        ...prev,
                                        purpose: value
                                    }));
                                }}
                                className={styles.select}
                                disabled={isLoading}
                            >
                                <option value="영수">영수</option>
                                <option value="청구">청구</option>
                                <option value="없음">없음</option>
                            </select>
                        </div>

                        <div className={styles.formGroup}>
                            <label>담당자 성명</label>
                            <input
                                type="text"
                                value={requestData.managerName}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setRequestData(prev => ({
                                        ...prev,
                                        managerName: value
                                    }));
                                }}
                                className={styles.input}
                                disabled={isLoading}
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label>담당자 번호</label>
                            <input
                                type="text"
                                value={requestData.managerNumber}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setRequestData(prev => ({
                                        ...prev,
                                        managerNumber: value
                                    }));
                                }}
                                className={styles.input}
                                disabled={isLoading}
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label>메일</label>
                            <input
                                type="text"
                                value={requestData.email}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setRequestData(prev => ({
                                        ...prev,
                                        email: value
                                    }));
                                }}
                                className={styles.input}
                                disabled={isLoading}
                            />
                        </div>

                        {/*요청 생성 버튼*/}
                        <Button
                            type="submit"
                            variant="primary"
                            size="large"
                            fullWidth
                            disabled={isLoading}
                        >
                            발행
                        </Button>
                    </form>
                </div>
            </Modal>
        </>
    );
};

export default CreateTaxInvoicePopUp;